document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.menu-toggle');
  const menu = document.querySelector('#mobile-menu');
  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      const isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!isOpen));
      toggle.setAttribute('aria-label', isOpen ? 'Open menu' : 'Close menu');
      menu.hidden = isOpen;
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { menu.hidden = true; toggle.setAttribute('aria-expanded', 'false'); } });
  }

  const initializeHero = (root) => {
    if (root.dataset.heroInitialized === 'true') return;
    root.dataset.heroInitialized = 'true';
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;
    const dots = [...root.querySelectorAll('[data-hero-dot]')];
    const status = root.querySelector('[data-hero-status]');
    let current = 0;
    let timer;
    const show = (target) => {
      current = (target + slides.length) % slides.length;
      slides.forEach((slide, index) => {
        slide.hidden = index !== current;
        if (slide.hidden) slide.setAttribute('aria-hidden', 'true');
        else slide.removeAttribute('aria-hidden');
      });
      dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === current)));
      if (status) status.textContent = `${root.dataset.slideLabel || 'Slide'} ${current + 1} / ${slides.length}`;
    };
    const stop = () => { if (timer) clearInterval(timer); timer = undefined; };
    const start = () => {
      stop();
      if (root.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        timer = setInterval(() => {
          if (!document.hidden) show(current + 1);
        }, Number(root.dataset.interval) || 5000);
      }
    };
    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      show(index);
      start();
    }));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        show(current + (event.key === 'ArrowRight' ? 1 : -1));
        start();
      }
    });
    let touchStart;
    root.addEventListener('touchstart', (event) => {
      touchStart = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
    }, { passive: true });
    root.addEventListener('touchend', (event) => {
      if (!touchStart) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.3) { show(current + (dx < 0 ? 1 : -1)); start(); }
      touchStart = undefined;
    }, { passive: true });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', (event) => { if (!root.contains(event.relatedTarget)) start(); });
    root.addEventListener('shopify:block:select', (event) => {
      const chosen = slides.findIndex((slide) => slide === event.target || slide.contains(event.target) || slide.dataset.blockId === event.detail?.blockId);
      if (chosen >= 0) { show(chosen); stop(); }
    });
    start();
  };
  document.querySelectorAll('[data-hero-carousel]').forEach(initializeHero);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-hero-carousel]').forEach(initializeHero);
  });
  const selector = document.querySelector('[data-variant-select]');
  const price = document.querySelector('[data-product-price]');
  const addButton = document.querySelector('[data-add-to-cart]');
  if (selector) selector.addEventListener('change', () => {
    const option = selector.selectedOptions[0];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (addButton && option) {
      const available = option.dataset.available === 'true';
      addButton.disabled = !available;
      addButton.textContent = available ? addButton.dataset.addLabel : addButton.dataset.soldOutLabel;
    }
  });
  const mainImage = document.querySelector('.product-main-image img');
  if (mainImage) document.querySelectorAll('[data-image-src]').forEach((button) => {
    button.addEventListener('click', () => { mainImage.src = button.dataset.imageSrc; mainImage.srcset = ''; });
  });
});
